import IPayload from "../interfaces/IPayload";
import IUsina from "../interfaces/IUsuario";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class UsuarioService {
    async getByEmail(filters: any) {
        return await api.get(`${resources.usuario}/GetByEmail/${ToQueryString(filters)}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.usuario}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async create(data: any) {
        return await api.post<IUsina>(`${resources.usuario}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.usuario}/Update`, data);
    }
}

export default new UsuarioService();
